import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import COLORS from "../../constants/colors";
import Loginleftimg from "../../assets/images/login_left_img.png";
import { useLoginMutation } from "../../api/auth/auth";
import { notifySuccess, notifyError } from "../../utils/ToastifyProvider";
import { useLoader } from "../../utils/LoaderContext";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [focusedInput, setFocusedInput] = useState("");
  const [showPassword, setShowPassword] = useState(false); // ✅ NEW STATE
  const { setLoading } = useLoader();

  const { mutate, isLoading } = useLoginMutation();

  const handleFormSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    mutate(
      { email, password },
      {
        onSuccess: (data) => {
          notifySuccess("Login successful!");
          
          // ✅ Dispatch custom event to trigger socket connection
          window.dispatchEvent(new Event("authChange"));
          
          navigate("/chats");
          setLoading(false);
        },
        onError: (err) => {
          notifyError(
            err.response?.data?.message || "Login failed. Please try again."
          );
          setLoading(false);
        },
      }
    );
  };

  return (
    <>
      <div className="flex flex-col md:flex-row w-full h-screen bg-white">
        {/* Logo */}
        <div className="absolute top-4 left-6 flex items-center gap-3">
          {/* <img src={Image} alt="Logo" className="w-[170px] md:w-[200px]" /> */}
        </div>

        {/* Left Image */}
        <div className="hidden md:flex flex-1 items-center justify-end pr-8">
          <img
            src={Loginleftimg}
            alt="Illustration"
            className="w-[90%] h-1/2 object-contain"
          />
        </div>

        {/* Right Form */}
        <div className="flex flex-1 items-center px-6">
          <form
            onSubmit={handleFormSubmit}
            className="w-full max-w-md flex flex-col gap-6"
          >
            <div>
              <h1 className="text-5xl font-bold">Welcome Back!</h1>
              <p className="text-gray-500 mt-1 text-xl">Login to continue</p>
            </div>

            {/* Email Input */}
            <div className="relative">
              <FaUser
                className={`absolute top-3.5 left-4 text-2xl transition ${
                  focusedInput === "email"
                    ? COLORS.iconFocus
                    : COLORS.iconDefault
                }`}
              />
              <input
                type="email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setFocusedInput("email")}
                onBlur={() => setFocusedInput("")}
                className={`w-full border border-solid rounded-md py-3 px-14 focus:outline-none transition text-lg ${
                  focusedInput === "email"
                    ? COLORS.borderFocus
                    : COLORS.borderDefault
                }`}
                required
              />
            </div>

            {/* Password Input with Eye Icon */}
            <div className="relative">
              <FaLock
                className={`absolute top-3.5 left-4 text-2xl transition ${
                  focusedInput === "password"
                    ? COLORS.iconFocus
                    : COLORS.iconDefault
                }`}
              />
              <input
                type={showPassword ? "text" : "password"} // ✅ TOGGLE TYPE
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocusedInput("password")}
                onBlur={() => setFocusedInput("")}
                className={`w-full border rounded-md py-3 px-14 pr-12 focus:outline-none text-lg transition ${
                  focusedInput === "password"
                    ? COLORS.borderFocus
                    : COLORS.borderDefault
                }`}
                required
              />
              {/* ✅ EYE ICON BUTTON */}
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-3.5 right-4 text-2xl text-gray-500 hover:text-gray-700 transition focus:outline-none"
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            {/* Buttons */}
            <div className="flex flex-wrap items-center gap-4 mt-2">
              <button
                type="submit"
                className={`bg-primary text-white rounded-full px-6 py-2 font-medium hover:opacity-90`}
                disabled={isLoading}
              >
                {isLoading ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;